import { render, staticRenderFns } from "./AttendanceDetailModal.vue?vue&type=template&id=72fa3e72&scoped=true"
import script from "./AttendanceDetailModal.vue?vue&type=script&lang=js"
export * from "./AttendanceDetailModal.vue?vue&type=script&lang=js"
import style0 from "./AttendanceDetailModal.vue?vue&type=style&index=0&id=72fa3e72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fa3e72",
  null
  
)

export default component.exports